import React from 'react'

import cx from 'helpers/cx'

const Card = ({
  title,
  panel = true,
  section = false,
  className,
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement> & {
  title?: string
  panel?: boolean
  section?: boolean
}) => {
  /* --------------------------------- Getters -------------------------------- */

  const cardClassName = cx(
    'card',
    panel && 'card-panel',
    (section || title) && 'card-section',
    className
  )

  /* ---------------------------------- Doms ---------------------------------- */

  return (
    <div className={cardClassName} {...rest}>
      {title && (
        <div className="card-title-row">
          <span className="card-accent" aria-hidden="true" />
          <h4 className="layout-section-title">{title}</h4>
        </div>
      )}
      {title ? <div className="card-body">{children}</div> : children}
    </div>
  )
}

export { Card }
